import LoginScreen from '../features/session/layouts/login-screen';

export default function LoginPage() {
    return <LoginScreen />;
}
